export const GTM_addToCart = (response,items,buttonElement) => {
  console.log('GTM_addToCart', response);
  Shopify.analytics.publish('gtm_add_to_cart', {
    currency: Shopify.currency.active,
    value: response?.items?.[0]?.final_price / 100,
    quick_add: (typeof buttonElement.dataset.quickaddCart !== 'undefined') ? true : false,
    items: response.items.map((item,index) => {
      item.quantity = items[index].quantity;
      // quantity is overridden by actual quantity added to cart
      return item
    }),
  });
}
window.GTM_addToCart = GTM_addToCart;

export const GTM_modifyCartAdd = (response) => {
  console.log('gtm_add_to_cart', response);

  Shopify.analytics.publish('gtm_add_to_cart', {
    currency: Shopify.currency.active,
    value: response?.items_added?.[0]?.presentment_price * response?.items_added?.[0]?.quantity,
    quick_add: false,
    items: response?.items_added.map((item) => {
      item.final_price = item.presentment_price * 100;
      return item;
    }),
  });
}
window.GTM_modifyCartAdd = GTM_modifyCartAdd;

export const GTM_removeFromCart = (response) => {
  console.log('GTM_removeFromCart', response);
  Shopify.analytics.publish('gtm_remove_from_cart', {
    currency: Shopify.currency.active,
    value: response?.items_removed?.[0]?.presentment_price * response?.items_removed?.[0]?.quantity,
    items: response?.items_removed.map((item) => {
      item.final_price = item.presentment_price * 100;
      return item;
    }),
  });
}
window.GTM_removeFromCart = GTM_removeFromCart;

export const GTM_removeFromCartLink = (item) => {
  console.log('GTM_removeFromCartLink', item);
  Shopify.analytics.publish('gtm_remove_from_cart', {
    currency: Shopify.currency.active,
    value: item.final_line_price / 100,
    items: [item],
  });
}
window.GTM_removeFromCartLink = GTM_removeFromCartLink;

export const GTM_plpViewItems = (items) => {
  console.log('GTM_plpViewItems', items);
  const itemsList = [];

  if(items.length > 0) {

    items.forEach((item) => {
      const itemJson = JSON.parse(item.dataset?.gtmItemsElJson);
      // add control class to prevent double tracking
      item.classList.add('gtm-item_viewed');

      // add item_select event
      item.addEventListener('click', () => {
        Shopify.analytics.publish('gtm_select_item', {
          currency: Shopify.currency.active,
          item_list_name: item?.dataset?.gtmItemsListName,
          items: [itemJson],
        });
      });


      // add item to collection
      itemsList.push(itemJson)
    });

    Shopify.analytics.publish('gtm_plp_view_items', {
      currency: Shopify.currency.active,
      item_list_name: items[0].dataset?.gtmItemsListName,
      items: itemsList,
    });
  }

}
window.GTM_plpViewItems = GTM_plpViewItems;

export const setupCookiesWrapperTracking = () => {
  // Function to monitor and track clicks on #cookies-wrapper
  // Check if the element already exists
  let cookiesWrapper = document.getElementById('cookies-wrapper');

  if (cookiesWrapper) {
    // If the element exists, add the event listener directly
    cookiesWrapper.addEventListener('click', function(e) {
      Shopify.analytics.publish('gtm_consent_expressed');
      console.log('Cookies wrapper clicked, event sent to GTM');
    });
  } else {
    // If the element doesn't exist, set up an observer to monitor when it's added
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            // Check if the node is an element and has the id 'cookies-wrapper'
            if (node.nodeType === 1 && node.id === 'cookies-wrapper') {
              node.addEventListener('click', function(e) {
                Shopify.analytics.publish('gtm_consent_expressed');
                console.log('Cookies wrapper clicked, event sent to GTM');
              });
              // Stop the observer once the element is found and configured
              observer.disconnect();
              return;
            }

            // Also check for the element inside the added node
            if (node.nodeType === 1 && node.querySelector) {
              const cookiesWrapper = node.querySelector('#cookies-wrapper');
              if (cookiesWrapper) {
                cookiesWrapper.addEventListener('click', function(e) {
                  Shopify.analytics.publish('gtm_consent_expressed');
                  console.log('Cookies wrapper clicked, event sent to GTM');
                });
                // Stop the observer once the element is found and configured
                observer.disconnect();
                return;
              }
            }
          }
        }
      });
    });

    // Start the observer with configuration options
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

// Function to calculate the SHA-256 hash of a string
export const sha256 = async (message) => {
  // Encode the message as UTF-8 buffer
  const msgBuffer = new TextEncoder().encode(message);
  // Generate the hash of the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  // Convert the buffer to hexadecimal string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}